import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Container, Link, Paper, Typography } from '@mui/material'

import { ReactComponent as Support } from '../../assets/icons/support.svg'
import useTranslations from '../../i18n/useTranslations'

import useStyles from './styles'

const openPrintManualPdf = async () => {
  // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
  // o será accesible vía API.
  const document = await fetch(
    process.env.PUBLIC_URL +
      '/documents/Manual usuario digital Configuración impresión.pdf',
  )
  const blob = await document.blob()
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
}

const PrintSettings = ({ children }) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <>
      <Typography variant="h1" className={clsx('mainTitle', classes.mainTitle)}>
        {t('print-settings:title')}
      </Typography>

      <Paper elevation={1} className={classes.paper}>
        <Container className={classes.mainContainer}>
          <Typography
            variant="h2"
            className={clsx('secondaryTitle', 'decorator')}
          >
            {t('print-settings:label-printing-configuration')}
          </Typography>

          {children}
        </Container>
        <Box className={classes.footerWrapper}>
          <Container className={classes.footer}>
            <Typography
              variant="h2"
              className={clsx('secondaryTitle', 'decorator', classes.subtitle)}
            >
              {t('print-settings:problems-installing-the-app')}
            </Typography>

            <Typography variant="body1" className={classes.weHelpYouText}>
              {t('print-settings:download-print-manual')}
              <Link
                component="button"
                variant="body1"
                onClick={openPrintManualPdf}
              >
                {t('print-settings:link-text')}
              </Link>
            </Typography>

            <Typography variant="body1" className={classes.weHelpYouText}>
              {t('print-settings:we-help-you')}
            </Typography>

            <Link
              className={classes.supportLink}
              href={`mailto:${t('print-settings:support-link')}`}
            >
              <Support /> {t('print-settings:support-link')}
            </Link>
          </Container>
        </Box>
      </Paper>
    </>
  )
}

PrintSettings.propTypes = {
  children: PropTypes.node,
}

export default PrintSettings
